import { useUser } from "./context/UserContext";
import "./App.css";
import {
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import Login from "./pages/Login";
import Forget from "./Components/Auth/Forget";
import Register from "./Components/Auth/Register";
import Profile from "./Components/AdminProfile/Profile";
import Home from "./Components/FrontPage/Home";
import ActiveBettors from "./Components/manageBattors/activeBattors/ActiveBettors";
import BettorDetails from "./Components/manageBattors/activeBattors/BettorDetails";
import NotificationPage from "./Components/manageBattors/sendNotification/NotificationPage";
import BannedBettors from "./Components/manageBattors/bannedBattors/BannedBettors";
import BannedBettorDetails from "./Components/manageBattors/bannedBattors/BannedBettorsDetails";
import AllBettors from "./Components/manageBattors/allBattors/AllBettors";
import EmailUnverified from "./Components/manageBattors/emailUnVerified/EmailUnverified";
import MobileUnverified from "./Components/manageBattors/mobileUnverified/MobileUnverified";
import KycPending from "./Components/manageBattors/kycpending/KycPending";
import KycUnverified from "./Components/manageBattors/kycUnverified/KycUnverified";
import WithBalance from "./Components/manageBattors/withBalannce/WithBalance";
import EmailUnverifiedDetails from "./Components/manageBattors/emailUnVerified/EmailUnverifiedDetails";
import KycPendingDetails from "./Components/manageBattors/kycpending/KycPendingDetails";
import KycUnverifiedDetails from "./Components/manageBattors/kycUnverified/KycUnverifiedDetails";
import MobileUnverifiedDetails from "./Components/manageBattors/mobileUnverified/MobileUnverifiedDetails";
import Categories from "./pages/Categories";
import Teams from "./pages/Teams";
import InSeasonLeagues from "./pages/leagues/InSeasonLeagues";
import InSeasonEnable from "./pages/leagues/InSeasonEnable";
import APIEnabled from "./pages/leagues/APIEnabled";
import AllLeagues from "./pages/leagues/AllLeagues";
import InSeasonDisabled from "./pages/leagues/InSeasonDisabled";
import ManualEnabled from "./pages/leagues/ManualEnabled";
import OpenForBettingGames from "./pages/manageGame/OpenForBettingGames";
import CloseForBetting from "./pages/manageGame/CloseForBetting";
import NotOpenForBetting from "./pages/manageGame/NotOpenForBetting";
import InPlayGames from "./pages/manageGame/InPlayGames";
import UpcomingGames from "./pages/manageGame/UpcomingGames";
import EndedGames from "./pages/manageGame/EndedGames";
import CancelledGames from "./pages/manageGame/CancelledGames";
import AllGames from "./pages/manageGame/AllGames";

// Support Tickets
import PendingTickets from "./pages/suportTicket/PendingTickets";
import AllTickets from "./pages/suportTicket/AllTickets";
import AnsweredTickets from "./pages/suportTicket/AnsweredTickets";
import ClosedTickets from "./pages/suportTicket/ClosedTickets";
import ReplyTicket from "./pages/suportTicket/ReplyTicket";

// Deposits
import PendingDeposite from "./pages/deposite/PendingDeposite";
import ApprovedDeposite from "./pages/deposite/ApprovedDeposite";
import SuccessfulDeposite from "./pages/deposite/SuccessfulDeposite";
import RejectedDeposite from "./pages/deposite/RejectedDeposite";
import AllDeposite from "./pages/deposite/AllDeposite";

// Withdrawals
import WithdrawalPending from "./pages/withdrawals/WithdrawalPending";
import ApprovedWithdrawal from "./pages/withdrawals/ApprovedWithdrawal";
import RejectedWithdrawals from "./pages/withdrawals/RejectedWithdrawals";
import AllWithdrawals from "./pages/withdrawals/AllWithdrawals";

// Declare Outcomes
import PendingOutcomes from "./pages/DeclareOutcome/PendingOutcomes";
import DeclaredOutcomes from "./pages/DeclareOutcome/DeclaredOutcomes";

// Bets Placed
import AllBets from "./pages/betsplaced/AllBets";
import LossBets from "./pages/betsplaced/LossBets";
import PendingBets from "./pages/betsplaced/PendingBets";
import RefundedBets from "./pages/betsplaced/RefundedBets";
import WonBets from "./pages/betsplaced/WonBets";

// Reports
import TransactionHistory from "./pages/reports/TransactionHistory";
import LoginHistory from "./pages/reports/LoginHistory";
import NotificationHistory from "./pages/reports/NotificationHistory";
import ReferralCommissions from "./pages/reports/ReferralCommissions";
import CreditHistory from "./pages/reports/CreditHistory";
import BetHistory from "./pages/reports/BetHistory";

// Extra
import ApplicationPage from "./pages/extra/Application";
import ServerPage from "./pages/extra/Server";
import CachePage from "./pages/extra/Cache";
import UpdatePage from "./pages/extra/Update";
import AllUsers from "./Components/Users/AllUsers/AllUsers";
import ViewUser from "./Components/Users/ViewUser/ViewUser";
import AllBattorsDetails from "./Components/manageBattors/allBattors/AllBattorsDetails";
import WithBalancDetails from "./Components/manageBattors/withBalannce/WithBalancDetails";
import AllProviders from "./Components/Casino/Providers/AllProviders";
import CasinoGames from "./Components/Casino/Games/AllGames";
import CasinoAnalytics from "./pages/reports/CasinoAnalytics";

import CasinoGameReport from "./pages/reports/CasinoGameReport";
import SportsGameReport from "./pages/reports/SportsGameReport";
import FrontendSettings from "./pages/FrontendSettings";
import BonusSettings from "./pages/extra/BonusSettings";
import CronJobs from "./pages/extra/CronJobs";

function App() {
  const { user } = useUser();

  return (
    <>
      <div className="App">
        <Routes>
          {user ? (
            <>
              {/* <Route path="/" element={<FrontPage />} /> */}
              <Route path="/" element={<Home />} />
              <Route path="/users" element={<AllUsers />} />
              <Route path="/users/:id" element={<ViewUser />} />
              <Route path="/active-bettors" element={<ActiveBettors />} />
              <Route path="/bettors/:id" element={<BettorDetails />} />
              {/* banned bettors */}
              <Route path="/banned-bettors" element={<BannedBettors />} />
              <Route
                path="/banned-bettors/:id"
                element={<BannedBettorDetails />}
              />
              <Route path="/all-bettors" element={<AllBettors />} />
              <Route path="/all-bettors/:id" element={<AllBattorsDetails />} />
              <Route path="/email-unverified" element={<EmailUnverified />} />
              <Route
                path="/email-unverified/:id"
                element={<EmailUnverifiedDetails />}
              />
              <Route path="/kyc-pending" element={<KycPending />} />
              <Route path="/kyc-pending/:id" element={<KycPendingDetails />} />
              <Route path="/with-balance" element={<WithBalance />} />
              <Route path="/with-balance/:id" element={<WithBalancDetails />} />
              <Route path="/Kyc-unverified" element={<KycUnverified />} />
              <Route
                path="/Kyc-unverified/:id"
                element={<KycUnverifiedDetails />}
              />
              <Route path="/mobile-unverified" element={<MobileUnverified />} />
              <Route
                path="/mobile-unverified/:id"
                element={<MobileUnverifiedDetails />}
              />
              <Route path="/categories" element={<Categories />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/send-notification" element={<NotificationPage />} />
              {/* leagues Routes  */}
              <Route path="/in-season-leagues" element={<InSeasonLeagues />} />
              <Route path="/in-season-enable" element={<InSeasonEnable />} />
              <Route path="/api-enabled" element={<APIEnabled />} />
              <Route path="/all-leagues" element={<AllLeagues />} />
              <Route
                path="/in-season-disabled"
                element={<InSeasonDisabled />}
              />
              <Route path="/manual-enabled" element={<ManualEnabled />} />
              <Route path="/frontend-settings" element={<FrontendSettings />} />

              {/* OpenForBettingGames  Routes  */}
              <Route
                path="/open-betting-games"
                element={<OpenForBettingGames />}
              />
              <Route path="/closed-betting" element={<CloseForBetting />} />
              <Route path="/not-open-betting" element={<NotOpenForBetting />} />
              <Route path="/in-play-games" element={<InPlayGames />} />
              <Route path="/upcoming-games" element={<UpcomingGames />} />
              <Route path="/ended-games" element={<EndedGames />} />
              <Route path="/cancelled-games" element={<CancelledGames />} />
              <Route path="/all-games" element={<AllGames />} />

              {/* Declare Outcomes */}
              <Route path="/pending-outcomes" element={<PendingOutcomes />} />
              <Route path="/declared-outcomes" element={<DeclaredOutcomes />} />

              {/* Bets Placed */}
              <Route path="/all-bets" element={<AllBets />} />
              <Route path="/loss-bets" element={<LossBets />} />
              <Route path="/pending-bets" element={<PendingBets />} />
              <Route path="/refunded-bets" element={<RefundedBets />} />
              <Route path="/won-bets" element={<WonBets />} />

              {/* Reports */}
              <Route path="/transaction-history" element={<TransactionHistory />} />
              <Route path="/login-history" element={<LoginHistory />} />
              <Route path="/notification-history" element={<NotificationHistory />} />
              <Route path="/referral-commissions" element={<ReferralCommissions />} />
              <Route path="/reports/credit" element={<CreditHistory />} />
              <Route path="/reports/bet" element={<BetHistory />} />
              <Route path="/reports/casino" element={<CasinoGameReport />} />
              <Route path="/reports/sports" element={<SportsGameReport />} />

              {/* Extra */}
              <Route path="/extra-application" element={<ApplicationPage />} />
              <Route path="/extra-server" element={<ServerPage />} />
              <Route path="/extra-cache" element={<CachePage />} />
              <Route path="/extra-update" element={<UpdatePage />} />
              <Route path="/cron-jobs" element={<CronJobs />} />

              {/* support ticket  */}
              <Route path="/pending-ticket" element={<PendingTickets />} />
              <Route path="/all-ticket" element={<AllTickets />} />
              <Route path="/answered-ticket" element={<AnsweredTickets />} />
              <Route path="/closed-ticket" element={<ClosedTickets />} />
              <Route path="/ticket-reply/:id" element={<ReplyTicket />} />

              {/* Departments / Deposits */}
              <Route path="/deposit-pending" element={<PendingDeposite />} />
              <Route path="/deposit-approved" element={<ApprovedDeposite />} />
              <Route
                path="/deposit-successful"
                element={<SuccessfulDeposite />}
              />
              <Route path="/deposit-rejected" element={<RejectedDeposite />} />
              <Route path="/deposit-all" element={<AllDeposite />} />
              <Route path="/bonus-settings" element={<BonusSettings />} />

              {/* Withdrawals */}
              <Route
                path="/withdrawal-pending"
                element={<WithdrawalPending />}
              />
              <Route
                path="/withdrawal-approved"
                element={<ApprovedWithdrawal />}
              />
              <Route
                path="/withdrawal-rejected"
                element={<RejectedWithdrawals />}
              />
              <Route path="/withdrawal-all" element={<AllWithdrawals />} />

              {/* Casino Management */}
              <Route path="/casino/providers" element={<AllProviders />} />
              <Route path="/casino/games" element={<CasinoGames />} />
              <Route path="/casino/analytics" element={<CasinoAnalytics />} />

              <Route path="/admin-profile" element={<Profile />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<Login />} />
              {/* <Route path="/" element={<FrontPage />} /> */}

              <Route path="/forget" element={<Forget />} />
              <Route path="/register" element={<Register />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
      </div>
    </>
  );
}

export default App;
